module.exports = __webpack_public_path__ + "static/media/tt_commons_demibold-webfont.133f7954.woff2";